import React from "react";
import { footer } from "../data/data";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div>{footer.copyright} &nbsp;</div>
    </footer>
  );
};

export default Footer;
